import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/prioritaeten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="Priority"
      returnRoute="/auswahlfelder/priorities"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const PrioritiesRoute = Route;
